import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { Button } from '../components/ui/button';
import { mockData } from '../data/mock';
import BannersCarousel from '../components/BannersCarousel';
import ModelShowcase from '../components/ModelShowcase'; // Updated import
import CapitalBeauty from '../components/CapitalBeauty';
import FeatureCards from '../components/FeatureCards';
import MapSection from '../components/MapSection';
import QuickNextSteps from '../components/QuickNextSteps';

import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import SEO from '../components/SEO';

const Home = () => {
  const { language } = useLanguage();
  const t = translations[language].home;

  const banners = [
    {
      image: "/assets/images/bj40-pro/bj40pro2.jpg",
      title: t.banners[0].title,
      subtitle: t.banners[0].subtitle,
      buttonText: t.banners[0].buttonText,
      buttonLink: "/off-road/bj40-pro"
    },
    {
      image: "/assets/images/homepage/banners/BJ40-Honor.jpg",
      title: t.banners[1].title,
      subtitle: t.banners[1].subtitle,
      buttonText: t.banners[1].buttonText,
      buttonLink: "/off-road/bj40-honor"
    },
    {
      image: "/assets/images/homepage/banners/BJ30.jpg",
      title: t.banners[2].title,
      subtitle: t.banners[2].subtitle,
      buttonText: t.banners[2].buttonText,
      buttonLink: "/off-road/bj30-hybrid"
    },
    {
      image: "/assets/images/homepage/banners/U5-Plus.jpg",
      title: t.banners[3].title,
      subtitle: t.banners[3].subtitle,
      buttonText: t.banners[3].buttonText,
      buttonLink: "/sedan/u5-plus"
    },
    {
      image: "/assets/images/homepage/banners/BAIC-Range.jpg",
      title: t.banners[4].title,
      subtitle: t.banners[4].subtitle,
      buttonText: t.banners[4].buttonText,
      buttonLink: "#"
      // buttonLink: "/all-terrain/BAIC-Range"
    }
  ];
  return (
    <>

      <div className="min-h-screen bg-white pt-20 md:pt-[120px]">
        <SEO
          title="BAIC Oman - Official Cars & Showroom in Oman | Buy BAIC Car"
          description="Explore BAIC cars in Oman - buy SUVs like BJ30 & X7, visit Official BAIC Cars Oman - BAIC Showroom in Oman"
          canonicalUrl="https://baicoman.com/"
        />
        <h1 className="sr-only">BAIC - Official Cars & Showroom in Oman | Buy BAIC Car</h1>
        {/* Hero Slider Section */}
        <BannersCarousel banners={banners} />

        {/* Model Showcase Section (Tabs + 360 Viewer) */}
        <ModelShowcase />

        {/* Capital Beauty Section */}
        <CapitalBeauty />

        {/* Feature Cards Section */}
        <FeatureCards />

        {/* Map Section */}
        <MapSection />

        {/* Quick Next Steps Section */}
        <QuickNextSteps />

      </div>
    </>
  );
};

export default Home;